import CloseIcon from "@/assets/icons/ontario-icon-close.svg";
import { lightColors, media, spacing } from "@ops-gsic/cxp-component-library-react";
import { styled } from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${lightColors.infoBG};
  border-bottom: 1px solid ${lightColors.border};
  padding: ${spacing.spacing4};
`;

export const InnerContainer = styled.div`
  width: 100%;
  max-width: 22.625rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${spacing.spacing4};

  @media ${media.small} {
    max-width: 48rem;
  }

  @media ${media.medium} {
    max-width: 72rem;
  }
`;

export const StyledCreateAccount = styled.div`
  display: flex;
  width: 100%;
  gap: ${spacing.spacing4};

  a {
    margin-right: ${spacing.spacing2};
  }

  svg {
    width: 24px;
  }
`;

export const StyledCloseIcon = styled(CloseIcon)`
  vertical-align: middle;

  &:focus,
  &:active {
    box-shadow: 0 0 0 ${spacing.spacing1}
      ${lightColors.infoBG};
    outline: ${spacing.spacing1} solid transparent;
  }
`;
